<template>
<!--   <div class="listing-page" :key='tags[0].id'> -->
  <div class="listing-page">
<!--
    <section class="page-header">
      <h1>Browse Locations</h1>
    </section>
-->
    <section class="page-header">
<!--       <h1 v-if="tags.length === 1">{{tags[0].name}}</h1> -->
<!--       <h1>{{pls.length}} Locations</h1> -->
      <h1>Browse Locations</h1>



      <div class="options">

        <h4>View Options</h4>

        <div class="photo-options">
          <label>Default Photo</label>
          <div class="radio-list">
            <p class="option" v-bind:class='{selected: photoselection == "relevant"}' @click='photoselection = "relevant"'><i></i> Most relevant</p>
            <p class="option" v-bind:class='{selected: photoselection == "default"}' @click='photoselection = "default"'><i></i> Default</p>
          </div>
        </div>

        <div class="grid-options">
          <label>Thumbnail Size</label>
          <div class="toggle-switch" v-bind:class='{switched: fullsizeview}' @click="toggleViewSize">
            <div class="option" v-bind:class='{highlighted: !fullsizeview}'><i class="material-icons">view_module</i><span> Grid</span></div>
            <div class="option" v-bind:class='{highlighted: fullsizeview}'><i class="material-icons">view_stream</i><span> Full</span></div>
            <div class="highlight"></div>
          </div>
        </div>

      </div>


      <div class="tags">
        <div class="tile" v-for="tag in tags">
          {{tag.name}} <a class="close material-icons" @click="removeTag(tag)">cancel</a>
        </div>
<!--
        <div>
          <router-link :to='"/browse?selections="+tagslugs.join()' class="changebutton">Change Search</router-link>
        </div>
-->
      </div>

      <h4 class="location-count" v-if="tags.length">{{pls.length}} Locations</h4>
      <h4 class="location-count" v-else>Showing featured locations</h4>

<!--
      <div class="filter">
        <h4>Filter these results</h4>
        <i class="material-icons">filter_list</i>
        <span v-for='rtag, index in relatedtags' v-if='index < 15 && rtag.id != tag.id'><router-link :to='"/browse/"+ tagid + "/" + rtag.id'>{{rtag.name}} ({{rtag.filteredcount}})</router-link></span>

      </div>
-->

      <span class="clear"></span>
    </section><!-- /page-header -->


    <section class="categories">
      <ul class="tabs">
        <li v-for="category in filteredCategories" v-if="category.name != 'Zip'" @click="tabShowing !== category.name ? tabShowing = category.name : tabShowing = false" v-bind:class='{selected: tabShowing === category.name}'>{{category.name}}</li>
      </ul>
      <div class="category" v-for="category in filteredCategories" v-if="category.name == tabShowing">
        <template v-for="(tag, index) in category.tags">
          <transition name="fade">
            <span>
            <div class="tile" v-if="!tag.selected">
              <router-link :to="'/browse/'+tag.slug" :event='""' @click.native.prevent.stop="selectTag(tag)">
                <label>{{tag.name}} <span class="count">{{ tag.plcount }}</span></label>
              </router-link>
            </div>{{' '}}
            <div class="tile selected" v-if="tag.selected" @click="removeTag(tag)">
                <label>{{tag.name}}</label>
            </div>{{' '}}
            </span>
          </transition>{{' '}}
        </template>
        <div class="tile no-tags" v-if="!category.tags.length">
          <label>No results</label>
        </div>
        <div class="justifier"></div> <div class="justifier"></div> <div class="justifier"></div> <div class="justifier"></div> <div class="justifier"></div>
      </div>
    </section><!-- /.categories -->



    <div class="pl-listing" v-bind:class='{grid: !fullsizeview, full: fullsizeview}'>
      <BackToTop></BackToTop>
      <template v-for='(PL, index) in pls'>
      <PLThumb :key='PL.plno' :PL='PL' :fullsizeview='fullsizeview' :tagids='tagids' :photofilter='photoselection' :showpullsheet='true' :lazy='true' />{{' '}}
      </template>
      <div class="justifier"></div> <div class="justifier"></div> <div class="justifier"></div> <div class="justifier"></div>
    </div>

  </div>
</template>

<script>
import PLThumb from './PLThumb'
import BackToTop from './BackToTop'
export default {
  name: 'Listing',
  data () {
    var fullsizeview = false
    if (this.$cookie.get('listSizeOption') === 'true') fullsizeview = true
    var tagslugs = []
    if (this.$route.params[0] !== undefined) {
      tagslugs = this.$route.params[0].split('/')
    }

    var tags = []
    var tagids = []

    var tagerrors = []

    tagslugs.forEach((tagslug) => {
      var tag = this.$root.getTagBySlug(tagslug)
      if (!tag) {
        tagerrors.push(tagslug)
        return
      }
      tags.push(tag)
      tagids.push(tag.id)
    })

    var pls = []
    if (tags.length > 0) {
      pls = this.$root.filterByTags(tags).pls
    } else {
      pls = this.$root.PLs.slice(0, 108)
    }

    return {
      tags: tags,
      tagslugs: tagslugs,
      tagids: tagids,
      pls: pls,
      photoselection: 'relevant',
      fullsizeview: fullsizeview,
      tabShowing: 'Area',
      tagerrors: tagerrors
    }
  },
  watch: {
    '$route' (to, from) {
      var tagslugs = [this.$route.params.slug]
      if (this.$route.params[0] !== undefined) {
        this.tagslugs = tagslugs.concat(this.$route.params[0].split('/'))
      }
    }
  },
  created () {
    this.updateMetaDescription()
    if (this.$root.authorizedUser) {
      if (this.$root.addresses.length === 0 && this.tagerrors.length) {
        console.log('need to rerender', this.$root.addresses.length)
        setTimeout(() => {
          this.tagerrors.forEach((tagslug) => {
            var tag = this.$root.getTagBySlug(tagslug)
            this.tags.push(tag)
            this.tagids.push(tag.id)
          })

          console.log('rerendering')
          this.reRender()
        }, 2000)
      }
    }
  },
  computed: {
    filteredCategories: function () {
      var selectedTags = this.tags
      var selectedTagSlugs = this.tagslugs
      if (selectedTags.length === 0) {
        return this.$root.categories
      } else {
        var filteredPLs = this.$root.filterByTags(selectedTags)
        var filteredTagCounts = filteredPLs.tagcounts
        this.filteredPLCount = filteredPLs.pls.length

        var filteredCategories = []
        var categories = this.$root.categories
        categories.forEach(function (category) {
          var newtags = []
          var newcategory = {
            name: category.name,
            id: category.id,
            slug: category.slug
          }
          category.tags.forEach(function (tag) {
            var newtag = {
              id: tag.id,
              featured: tag.featured,
              image: tag.image,
              name: tag.name,
              slug: tag.slug,
              categoryname: category.name
            }
            if (+tag.id in filteredTagCounts) {
              newtag.plcount = filteredTagCounts[+tag.id]
            } else {
              newtag.plcount = 0
            }
            if (selectedTagSlugs.indexOf(newtag.slug) === -1) {
              newtag.selected = false
              if (newtag.plcount > 0) newtags.push(newtag)
            } else {
              newtag.selected = true
              newtags.unshift(newtag)
            }
          })
          newcategory.tags = newtags
          filteredCategories.push(newcategory)
        })
        return filteredCategories
      }
    }
  },
  methods: {
    toggleViewSize: function () {
      this.fullsizeview = !this.fullsizeview
      this.$cookie.set('listSizeOption', this.fullsizeview, 365)
    },
    removeTag: function (tagtoremove) {
      var indextoremove = 99
      this.tags.forEach(function (tag, index) {
        if (tag.id === tagtoremove.id) indextoremove = index
      })
      this.tags.splice(indextoremove, 1)
      this.reRender()
      var newpath = '/browse/' + this.tagslugs.join('/')
      history.replaceState({}, null, newpath)
    },
    selectTag: function (tag) {
      this.tags.push(tag)
      this.reRender()
      var newpath = '/browse/' + this.tagslugs.join('/')
      history.replaceState({}, null, newpath)
    },
    reRender: function () {
      if (this.tags.length > 0) {
        this.pls = this.$root.filterByTags(this.tags).pls
      } else {
        this.pls = this.$root.PLs.slice(0, 108)
      }
      var tagslugs = []
      var tagids = []
      this.tags.forEach(function (tag) {
        tagslugs.push(tag.slug)
        tagids.push(tag.id)
      })
      this.tagslugs = tagslugs
      this.tagids = tagids
      this.updateMetaDescription()
    },
    updateMetaDescription () {
      if (this.tags.length > 0) {
        if (this.tags.length === 1) {
          document.title = this.tags[0].name + ' - Production Locations'
          if (this.tags[0].categoryname === 'Feature') {
            document.head.querySelector('meta[name=description]').content = 'Find filming locations with ' + this.tags[0].name + ' for your film, TV, or photo production in Los Angeles.'
          } else {
            document.head.querySelector('meta[name=description]').content = 'Find a ' + this.tags[0].name + ' location for your film, TV, or photo production in Los Angeles.'
          }
        } else {
          var areatags = []
          var othertags = []
          this.tags.forEach(function (tag) {
            if (tag.categoryname === 'Area') {
              areatags.push(tag.name)
            } else {
              othertags.push(tag.name)
            }
          })
          if (areatags.length && othertags.length) {
            document.title = othertags.join(', ') + ' in ' + areatags.join(', ') + ' - Production Locations'
            document.head.querySelector('meta[name=description]').content = othertags.join(', ') + ' filming locations in ' + areatags.join(', ') + '.'
          } else {
            if (areatags.length) {
              document.title = areatags.join(', ') + ' - Production Locations'
              document.head.querySelector('meta[name=description]').content = 'Locations available for film, TV, and photo shoots in ' + areatags.join(', ') + '.'
            } else {
              document.title = othertags.join(', ') + ' - Production Locations'
              document.head.querySelector('meta[name=description]').content = othertags.join(', ') + ' locations available for film use in Los Angeles.'
            }
          }
        }
      } else {
        document.title = 'Browse all ' + this.$root.PLs.length.toLocaleString() + ' locations for filming - Production Locations'
        document.head.querySelector('meta[name=description]').content = 'Browse our extensive database of filming locations around Los Angeles, each with tons of photos. Search by area, features, styles and building types.'
      }

/*
      document.title = 'PL' + this.$route.params.plno + ' ' + this.PLDetails.property_city + ' ' + tags['Type'].join('/') + ' for filming - Production Locations'
      document.head.querySelector('meta[name=description]').content = 'A ' + tags['Style'].join(', ') + ', ' + tags['Type'].join(', ') + ' location in ' + tags['Area'][0] + ' available for film, TV, and photo shoots.'
*/
    }

  },
  components: {
    PLThumb,
    BackToTop
  },
  mounted: function () {
    this.$root.logActivity('Browsing tags ' + this.tagslugs.join(','))
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/_mixins.scss";
.page-header {
  border-bottom: 1px solid #efefef;
  h4.location-count {
    font-weight: 300;
    margin: 0px;
  }
}
.page-header h1 {
  display: inline-block;
  vertical-align: top;
  width: 70%;
  @include bp(most) {
    width: 55%;
  }
  @include bp(medlarge) {
    width: 65%;
  }
}

.filter {
  display: inline-block;
  vertical-align: top;
  width: 50%;
  padding: 1.25em 0 1.25em 2em;
  font-size: 12px;
  position: relative;
  i {
    position: absolute;
    left: 0px;
    top: 50%;
    margin-top: 6px;
    color: #979797;
    font-size: 18px;
  }
  span {
    color: $blue;
    text-decoration: underline;
    display: inline-block;
    margin-right: .75em;
    line-height: 1.5;
    cursor: pointer;
    a {
      color: $blue;
    }
  }
  h4 {
    margin-bottom: .25em;
    color: $darkgrey;
    font-weight: 500;
  }
}

.options {
  display: inline-block;
  float: right;
  vertical-align: top;
  width: 60px;
  margin-top: 5px;
  @include bp(most) {
    width: 38%;
    border-left: 1px solid #DFDFDF;
    padding-left: 2em;
    margin-top: 0;
  }
  @include bp(medlarge) {
    width: 30%;
    padding-left: 3em;
  }
  h4 {
   color: $darkgrey;
   font-size: 18px;
   font-weight: 300;
   margin: .5em 0 1em;
   display: none;
   @include bp(most) {
     display: block;
   }
  }
  label {
    font-size: 12px;
    font-weight: 500;
    color: $darkgrey;
    line-height: 2;
    display: none;
    @include bp(most) {
      display: block;
    }
  }
}

.photo-options {
  display: none;
  vertical-align: top;
  width: 49%;
  @include bp(most) {
    display: inline-block;
  }

  p {
    margin: .25em 0;
    color: $notblack;
    font-weight: 300;
    cursor: pointer;
    position: relative;
    i {
      display: inline-block;
      width: 13px;
      height: 13px;
      border: 2px solid #D8D8D8;
      background: #D8D8D8;
      border-radius: 7px;
      box-sizing: border-box;
      vertical-align: middle;
      margin-right: .5em;
    }
    &.selected i {
      background: $blue;
    }
  }
}
.grid-options {
  display: inline-block;
  vertical-align: top;
  width: 55px;
  @include bp(most) {
    width: 40%;
  }
  .toggle-switch {
    background: #D8D8D8;
    border-radius: 4px;
    position: relative;
    font-size: 12px;
    font-weight: 300;
    cursor: pointer;
		@include noselect();
    .option {
      display: inline-block;
      width: 47%;
      position: relative;
      z-index: 2;
      box-sizing: border-box;
      padding: .25em 0 .25em .25em;
      @include bp(most) {
        padding: .25em;
        width: 48%;
      }
      i {
        font-size: 18px;
        vertical-align: middle;
      }
      &.highlighted {
        color: #FFF;
      }
    }
    .highlight {
      width: 49%;
      background: $blue;
      position: absolute;
      border-radius: 4px;
      left: 0px;
      top: 0px;
      z-index: 1;
      height: 2em;
      transition: left .1s;
    }
    &.switched .highlight {
      left: 50%;
    }
    span {
      display: none;
      @include bp(most) {
        display: inline;
      }
    }
  }
}

.tags {
  vertical-align: top;
  position: relative;
  padding: .75em 0;
  font-size: 12px;
  @include bp(most) {
    display: inline-block;
    width: 50%;
    padding: 1.25em 0;
  }
  .tile {
      display: inline-block;
      border: 1px solid #3b4244;
      display: inline-block;
      box-sizing: border-box;
      margin-bottom: .5%;
      margin-right: 1em;
      padding: .5em;
      font-size: 10px;
      font-weight: 400;
      padding:  .5em 2.75em .5em 1em;
      position: relative;
      border-radius: 50px;
      @include bp(most) {
        font-size: 14px;
        padding:  .25em 2.25em .325em 1em;
      }
    a.close {
        cursor: pointer;
        position: absolute;
        right: 6px;
        font-size: 17px;
        line-height: 20px;
        top: 50%;
        margin-top: -11px;
        text-decoration: none;
        color: $notblack;
        @include bp(most) {
          margin-top: -10px;
          font-size: 20px;
        }
    }
  }
  a.changebutton {
      display: inline-block;
      background: $blue;
      border: 1px solid #1f6ac3;
      display: inline-block;
      box-sizing: border-box;
      margin-bottom: .5%;
      margin-right: 1em;
      padding: .5em;
      font-size: 12px;
      font-weight: 500;
      padding:  .25em 1em .5em 1em;
      position: relative;
      border-radius: 50px;
      text-decoration: none;
      color: #FFF;
      margin-top: .5em;
      @includebp(most) {
        margin-top: 1em;
        font-size: 14px;
        padding:  .25em 1em .5em 1em;
      }
  }
  p.no-tags {
    font-size: 1.25em;
    font-weight: 300;
    margin: .25em 0 .5em;
  }
}

.pl-listing {
 padding: 1%;
}
.pl-listing.grid {
  text-align: justify;
}
.justifier {
  width: 49%;
  display: inline-block;
  height: 1px;
  @include bp(most) {
    width: 32.7%;
  }
  @include bp(large) {
    width: 24%;
  }
}

section.categories {
  ul.tabs {
    list-style-type: none;
    margin: 0px;
    padding: 0 0 0 1em;
    background: $lightGrey;
    text-align: center;
    li {
      display: inline-block;
      padding: .75em 1.75em .5em;
      font-weight: 300;
      font-size: 1em;
      cursor: pointer;
      border-bottom: 4px solid $lightGrey;
      box-sizing: border-box;
      color: #BFBFBF;
      @include noselect();
      &:hover {
        color: $notblack;
      }
      &.selected {
        border-bottom: 4px solid $yellow;
        color: $notblack;
      }
      @include bp(smallmobile) {
        padding: .75em 1em .5em;
      }
      @include bp(most) {
        font-size: 1.75em;
        text-align: left;
      }
    }
    @include bp(most) {
      text-align: left;
    }

  }
  .category {
    padding: 1em 1em .25em;
    text-align: justify;
    border-bottom: 2px solid $notblack;
    margin-bottom: .5em;
    .tile {
      backface-visibility: #FFF;
      border: 1px solid #DFDFDF;
      display: inline-block;
      width: 49%;
      padding: 0;
      box-sizing: border-box;
      margin-bottom: 2%;
      position: relative;
      vertical-align: top;
      @include noselect();
      @include bp(largemobile) {
        width: 32.25%;
        margin-bottom: .5%;
      }
      @include bp(medium) {
        width: 24.25%;
        margin-bottom: .5%;
      }
      @include bp(large) {
        width: 19.25%;
        margin-bottom: .5%;
      }
      @include bp(xlarge) {
        width: 16.25%;
      }
      &:hover {
        border: 1px solid $notblack;
      }
      a {
        color: $notblack;
        text-decoration: none;
        display: block;
      }
      &.selected {
/*         border: 1px solid $notblack; */
        label {
          background: $yellow;
        }
      }
      label {
        display: block;
        cursor: pointer;
        font-size: 14px;
        font-weight: 300;
        padding:  .5em;
        background: #FFF;
/*         transition: background-color .25s; */
        @include bp(most) {
          font-size: 18px;
        }
      }
      .count {
        position: absolute;
        font-size: .5em;
        right: 1em;
        color: #929292;
        height: 1em;
        top: 50%;
        margin-top: -.5em;
        @include bp(most) {
          right: 1em;
          font-size: .625em;
        }
      }
      &::before {
        display: inline;
      }
      &.no-tags {
        border: 1px solid #FFF;
        label {
          cursor: default;
          color: #BFBFBF;
        }
      }
    }
    .justifier {
      width: 49%;
      display: inline-block;
      height: 1px;
      @include bp(largemobile) {
        width: 32.25%;
      }
      @include bp(medium) {
        width: 24.25%;
      }
      @include bp(large) {
        width: 19.25%;
      }
      @include bp(xlarge) {
        width: 16.25%;
      }
    }
    .fade-leave-active, .fade-enter-active {
/*       transition: height .5s, margin .5s, padding .5s, width .5s; */
      transition: opacity .5s;
      opacity: 1;
      div.tile {
        transition: width .5s;
        overflow: hidden;
        white-space: nowrap;
        border: 0px none;
      }
    }

    .fade-leave-to, .fade-enter {
      opacity: 0;
      div.tile {
/*         width: 0px; */
      }
    }
  }
}


</style>



// WEBPACK FOOTER //
// Listing.vue?13b52b7e